/**
 * @generated SignedSource<<c49c81191768528ade71aee5c65f89c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type FlightProvider = "KIWI" | "WAAVO";
import { FragmentRefs } from "relay-runtime";
export type FlightListRow_flight$data = {
  readonly createdAt: string | null;
  readonly id: string;
  readonly provider: FlightProvider;
  readonly " $fragmentSpreads": FragmentRefs<"EntityTableRow_entity" | "FlightListLastPriceChange_flight" | "FlightListLastUpdate_flight" | "FlightListPrice_flight" | "FlightListProvider_flight" | "FlightShortDetails_flight" | "FlightStatus_flight">;
  readonly " $fragmentType": "FlightListRow_flight";
};
export type FlightListRow_flight$key = {
  readonly " $data"?: FlightListRow_flight$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightListRow_flight">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlightListRow_flight",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "provider",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntityTableRow_entity"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FlightShortDetails_flight"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FlightListPrice_flight"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FlightListLastPriceChange_flight"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FlightListLastUpdate_flight"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FlightListProvider_flight"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FlightStatus_flight"
    }
  ],
  "type": "Flight",
  "abstractKey": null
};

(node as any).hash = "0252be4f3b19718b1cb3c7e6f2c5608d";

export default node;
